import { render, staticRenderFns } from "./ExistingTicket.vue?vue&type=template&id=6a237b44&scoped=true&"
import script from "./ExistingTicket.vue?vue&type=script&lang=js&"
export * from "./ExistingTicket.vue?vue&type=script&lang=js&"
import style0 from "./ExistingTicket.vue?vue&type=style&index=0&id=6a237b44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a237b44",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
